import * as apiFactory from "./ApiFactory";
import { BrandDocumentClassification } from "@/models/BrandDocumentClassification";
import { Api } from "./Api";

export async function brandMapping(): Promise<{ [x: string]: string }> {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<{ [x: string]: string }>("api/brand");
}

export async function documentClassifications(
  clientName: string,
  brand: string,
): Promise<BrandDocumentClassification[]> {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<BrandDocumentClassification[]>(["api/branddocumentClassification", clientName, brand]);
}
